export const methods = {
  async reload() {
    this.loading = true

    this.loading = false
  }
}
